module.exports = __webpack_public_path__ + "img/text-10.fbf647f5.png";